import React, { useState } from 'react';
import css from './Homefaq.module.css';
import IconCollection from '../../IconCollection/IconCollection';
import classNames from 'classnames';

const tabContent = [
  [
    {
      question: 'Do I pay if I don’t like the photos?',
      answer: 'No. Browse for free; pay only for the ones you choose.',
    },
    {
      question: 'Where do I see prices?',
      answer: 'Clearly shown in your gallery before checkout (set by your photographer).',
    },
    {
      question: 'How fast do I get the files?',
      answer: 'Instantly after payment—high-resolution downloads.',
    },
    {
      question: 'What about my data?',
      answer: 'GDPR-compliant. Your private gallery link is just for you.',
    },
  ],
  [
    {
      question: 'Do clients actually buy?',
      answer:
        'Often—because they only pay for what they love. Private gallery + watermarked previews + simple checkout make buying feel natural.',
    },
    {
      question: 'When do I get paid?',
      answer: 'Right after each client purchase via Stripe—automatic payout to your bank.',
    },
    {
      question: 'How much does Sihmo cost?',
      answer: '10% commission per sale. No monthly fees.',
    },
    {
      question: 'Do I have to upload a certain number of photos?',
      answer: 'No—upload your best. Quality beats quantity.',
    },
    {
      question: 'Am I locked in to Sihmo?',
      answer: 'No exclusivity or shifts. Use Sihmo when it suits you.',
    },
    {
      question: 'Can I set bundles as well as per-photo pricing?',
      answer: 'Yes—set per-photo and bundle prices per session.',
    },
  ],
];

export default function HomeFaq({ tabEnabled = false, tabs = [], fromFAQSection }) {
  const [openIndex, setOpenIndex] = useState(0);
  const [activeTab, setActiveTab] = useState(0);

  const toggle = i => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <>
      {tabEnabled && tabs.length > 0 && (
        <div className={css.tabsContainer}>
          {tabs.map((tab, i) => (
            <button
              key={i}
              className={`${css.tabButton} ${activeTab === i ? css.tabButtonActive : ''}`}
              onClick={() => {
                setActiveTab(i);
                setOpenIndex(0);
              }}
            >
              {tab}
            </button>
          ))}
        </div>
      )}

      <div className={classNames(css.faqWrapper, fromFAQSection && css.faqWrapperFromFAQSection)}>
        {tabContent[activeTab].map((item, i) => (
          <div key={i} className={css.faqItem}>
            <button className={css.faqQuestion} onClick={() => toggle(i)}>
              <span
                className={classNames(
                  openIndex === i ? css.faqQuestionHighlight : null,
                  fromFAQSection && openIndex === i && css.faqQuestionFromFAQSection
                )}
              >
                {item.question}
              </span>
              <span className={css.icon}>
                {openIndex === i ? (
                  <IconCollection name={'faq_minus'} />
                ) : (
                  <IconCollection name={'faq_plus'} />
                )}
              </span>
            </button>

            {openIndex === i && <div className={css.faqAnswer}>{item.answer}</div>}
          </div>
        ))}
      </div>
    </>
  );
}
